import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
  SiMacos,
  SiVmware,
  SiGrafana,
  SiJunit5,
  SiChatbot,
  SiCloudflare,
  SiGooglecloud,


} from "react-icons/si";
import { DiVim } from "react-icons/di";

const tools = [
  { icon: <SiMacos />, name: "macOS" },
  { icon: <SiVisualstudiocode />, name: "VS Code" },
  { icon: <DiVim />, name: "Vim" },
  { icon: <SiPostman />, name: "Postman" },
  { icon: <SiJunit5 />, name: "JUnit" },
  { icon: <SiVmware />, name: "VMware" },
  { icon: <SiGrafana />, name: "Grafana" },
  { icon: <SiSlack />, name: "Slack" },
  { icon: <SiVercel />, name: "Vercel" },
  { icon: <SiChatbot />, name: "Claude Code" },
  { icon: <SiCloudflare />, name: "Cloudflare" },
  { icon: <SiGooglecloud />, name: "Google Cloud" },
];

function Toolstack() {
  return (
    <Row className="g-3 justify-content-center" style={{ paddingBottom: "50px" }}>
      {tools.map((tool) => (
        <Col xs={6} md={4} lg={3} key={tool.name}>
          <div className="tech-icons tech-icons-labeled">
            <div>{tool.icon}</div>
            <p className="tech-icon-label">{tool.name}</p>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
